import { useTranslation } from 'react-i18next';

import DeclineIcon from 'assets/decline-icon.svg';
import {
  PlanInfoContainerStyled,
  ElectionTitleWrapperStyled,
  DeclineIconSyled,
} from '../../CoverageCardStyled';
import { DeclineTextWrapperStyled } from './DeclineInfoStyled';

interface DeclineInfoProps {
  benefitName: string;
}

export const DeclineInfo = ({ benefitName }: DeclineInfoProps) => {
  const { t } = useTranslation('pages.benefits');
  const isScreenLarge = window.innerWidth > 1199;

  return (
    <PlanInfoContainerStyled className="mb-0">
      <ElectionTitleWrapperStyled className="title d-lg-block d-none">
        <h3 className="mb-0">{benefitName}</h3>
      </ElectionTitleWrapperStyled>
      <div className="d-flex justify-content-between d-lg-none mr-2_5">
        <ElectionTitleWrapperStyled className="title d-lg-none">
          <h3 className="mb-0">{benefitName}</h3>
        </ElectionTitleWrapperStyled>
        <DeclineIconSyled>
          <img
            src={DeclineIcon}
            alt="Decline Icon"
            className="mr-2 mb-0"
            height="100%"
          />
        </DeclineIconSyled>
      </div>
      <div className="declined-box">
        <DeclineTextWrapperStyled>
          {isScreenLarge &&
            <img
              src={DeclineIcon}
              alt="Decline Icon"
              className="mr-2 mb-0"
              height="100%"
            />}
          <p className="mb-0">{t('coverageDeclined')}</p>
        </DeclineTextWrapperStyled>
      </div>
    </PlanInfoContainerStyled>
  );
};
